import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import {
    getAccountExitPassListUrl, APPROVE_REJECT_EXIT_PASS, resubmitExitPassUrl, approveRejectExitPassUrl,
    RESUBMIT_EXIT_PASS, GET_ACCOUNT_EXIT_PASS_LIST, headers, approveWaiveOffUrl, APPROVE_WAIVEOFF, insertExitPassOTPUrl, dismantleStallHMUrl, DISMANTLE_STALL_HM, verifyExitPassOTPUrl, INSERT_EXIT_PASS_OTP, VERIFY_EXIT_PASS_OTP, fetchAuthReport, GET_RECEIPT_PDF_ACTION_TYPE, CHECK_IF_APPROVED, checkIfApprovedUrl, getDamageListUrl, GET_DAMAGE_LIST, getDamageDetailsUrl, insertDamageUrl,
    GET_DAMAGE_DETAILS,
    updateDamageApproveStatusUrl,
    UPDATE_DAMAGE_APPROVE_STATUS
} from "../../../utils/constants";

export const getAccountExitPassList_action = (ExitNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, ContractorCompanyName, DamageStatusID, IsAllRecord) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExitNo: ExitNo,
            HallId: HallId,
            ZoneId: ZoneId,
            ExhRegistrationNo: ExhRegistrationNo,
            CompanyName: CompanyName,
            ContractorCompanyName: ContractorCompanyName,
            DamageStatusID: DamageStatusID,
            IsAllRecord: IsAllRecord,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getAccountExitPassListUrl, params, headers)

        dispatch({
            type: GET_ACCOUNT_EXIT_PASS_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}


export const getDamageList_action = (ExhibitorName,
    ExhRegistrationNo,
    CompanyName) => async (dispatch) => {
        try {
            const params = {
                UserId: '',
                ExhibitionID: 3,
                ExhibitorName: ExhibitorName,
                ExhRegistrationNo: ExhRegistrationNo,
                CompanyName: CompanyName,
            }
            console.log("getPaymentList_action Action------->", params)

            const res = await axiosGet(getDamageListUrl, params, headers)

            dispatch({
                type: GET_DAMAGE_LIST,
                payload: res,
            });
            return Promise.resolve(res)
        } catch (error) {
            return Promise.reject(error)
        }
    }

export const insertExitPassOTP_action = (ExitPassHdrID, table, url, ExitNo, firstNameSS, adminEmail, adminUserId, Outstanding) => async (dispatch) => {
    try {
        const params = {
            UserID: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExitPassHdrID: ExitPassHdrID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            table: table,
            approveUrl: url,
            exitNo: ExitNo,
            reqPerson: firstNameSS,
            adminEmail: adminEmail,
            adminUserId: adminUserId,
            outstadning: Outstanding
        }

        const res = await axiosPost(insertExitPassOTPUrl, params, headers)

        dispatch({
            type: INSERT_EXIT_PASS_OTP,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDamageDetails_action = (UserId, ExhibitionID, ExhRegistrationID, VendorID, ExhExitPassHdrID) => async (dispatch) => {
    try {
        const params = {
            UserId: UserId,
            ExhibitionID: ExhibitionID,
            ExhRegistrationID: ExhRegistrationID,
            ExhExitPassHdrID: ExhExitPassHdrID,
            VendorID: VendorID
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getDamageDetailsUrl, params, headers)

        dispatch({
            type: GET_DAMAGE_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const checkIfApproved_action = (ExitpassHdrID) => async (dispatch) => {
    try {
        const params = {
            // UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // Otp: Otp,
            ExitpassHdrID: ExitpassHdrID,
            // ExhRegistrationID: id
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(checkIfApprovedUrl, params, headers)

        dispatch({
            type: CHECK_IF_APPROVED,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}


export const verifyExitPassOTP_action = (Otp, ExitpassHdrID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            Otp: Otp,
            ExitpassHdrID: ExitpassHdrID,
            // ExhRegistrationID: id
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(verifyExitPassOTPUrl, params, headers)

        dispatch({
            type: VERIFY_EXIT_PASS_OTP,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const approveWaiveOff_action = (userId, ExitpassHdrID) => async (dispatch) => {
    try {
        const params = {
            UserID: userId,
            // Otp: exitPassId,
            ExitPassHdrID: ExitpassHdrID,
            // ExhRegistrationID: id
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(approveWaiveOffUrl, params, headers)

        dispatch({
            type: APPROVE_WAIVEOFF,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getExitPassPdf_action = (id) => async (dispatch) => {
    try {
        var list = [];
        const mapdata1 = {
            "ParameterName": "@ExhExitpassHdrID",
            "ParameterValue": id,
            "ParameterDataType": "int"
        }
        list.push(mapdata1);
        const mapData = {
            "report_name": 'ExitPass.rpt',
            "parameter_details": list
        }
        const res = await axiosPost(fetchAuthReport, mapData);
        dispatch({
            type: GET_RECEIPT_PDF_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const approveRejectExitPass_action = (ExitPassHdrID, ExhRegistrationID, IsApprove, RejectRemark, IsWaiveoff, REpersonName, REcompanyName, REcontactNo, REemailID, ExitNo, approvedByName, remark, mailData, ITMEStaffName, IssuedDate) => async (dispatch) => {
    try {
        const params = {
            UserID: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExitpassHdrID: ExitPassHdrID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhRegistrationID: ExhRegistrationID,
            IsApprove: IsApprove,
            RejectRemark: RejectRemark,
            IsWaiveoff: IsWaiveoff,
            ExitPersonName: REpersonName,
            ExitCompanyName: REcompanyName,
            ExitMobileNo: REcontactNo,
            ExitNo: ExitNo,
            ExitEmailID: REemailID,
            mailData: mailData,
            ApprovedByName: approvedByName,
            ApprovedRemark: remark,
            ITMEStaffName: ITMEStaffName,
            IssuedDate: IssuedDate
        }

        const res = await axiosPost(approveRejectExitPassUrl, params, headers)

        dispatch({
            type: APPROVE_REJECT_EXIT_PASS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const resubmitExitPass_action = (ExitPassHdrID) => async (dispatch) => {
    try {
        const params = {
            UserID: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExitpassHdrID: ExitPassHdrID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            // ExhRegistrationID: id
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(resubmitExitPassUrl, params, headers)

        dispatch({
            type: RESUBMIT_EXIT_PASS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const dismantleStallHM_action = (ExhRegistrationID, vendorID, arr, ExhExitPassHdrID) => async (dispatch) => {
    try {
        const params = {
            UserId: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationID: ExhRegistrationID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            damageDocList: arr,
            VendorID: vendorID,
            mailData: {},
            ExhExitPassHdrID: ExhExitPassHdrID,
            // ExhRegistrationID: id
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosPost(dismantleStallHMUrl, params, headers)

        dispatch({
            type: DISMANTLE_STALL_HM,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertDamage_action = (ExhRegistrationID, vendorID, arr, ExhExitPassHdrID, isLastExitPass, mailData, DamageStatusID, Remark) => async (dispatch) => {
    try {
        const params = {
            UserId: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationID: ExhRegistrationID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            damageDocList: arr,
            VendorID: vendorID,
            mailData: mailData,
            ExhExitPassHdrID: ExhExitPassHdrID,
            isLastExitPass: isLastExitPass,
            // ExhRegistrationID: id,
            DamageStatusID: DamageStatusID,
            Remark: Remark
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosPost(insertDamageUrl, params, headers)

        dispatch({
            type: DISMANTLE_STALL_HM,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateDamageApproveStatus_action = (ExhExitPassHdrID, DamageStatusID, DamageApprovedRemark) => async (dispatch) => {
    try {
        const params = {
            UserId: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhExitPassHdrID: ExhExitPassHdrID,
            DamageStatusID: DamageStatusID,
            DamageApprovedRemark: DamageApprovedRemark,
        }

        const res = await axiosPost(updateDamageApproveStatusUrl, params, headers)

        dispatch({
            type: UPDATE_DAMAGE_APPROVE_STATUS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}